import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { Field, email, form, required } from '@angular/forms/signals';
import { Router, RouterLink } from '@angular/router';
import { LoginForm } from '@core/interfaces/login-form';
import { Auth } from '@core/services/auth';
import { InputPassword } from '@shared/components/inputs/input-password/input-password';
import { InputText } from '@shared/components/inputs/input-text/input-text';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-form-login',
  imports: [Field, InputText, InputPassword, ButtonModule, RouterLink],
  templateUrl: './form-login.html',
  styleUrl: './form-login.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormLogin {
  private router = inject(Router);
  private auth = inject(Auth);
  private messageService = inject(MessageService);

  loginModel = signal<LoginForm>({
    email: '',
    password: '',
  });

  loginForm = form(this.loginModel, schemaPath => {
    required(schemaPath.email, { message: 'El correo es obligatorio' });
    email(schemaPath.email, {
      message: 'Ingrese una dirección de correo electrónico válida',
    });
    required(schemaPath.password, { message: 'La contraseña es obligatoria' });
  });

  async login(event: Event) {
    event?.preventDefault();

    if (!this.loginForm().valid()) {
      this.showMessage('Formulario inválido.');
      return;
    }

    try {
      const { email, password } = this.loginForm().value();
      await this.auth.signIn(email, password).then(async () => {
        // Verificar si hay una URL de retorno guardada
        const returnUrl = sessionStorage.getItem('returnUrl');

        if (returnUrl) {
          // Limpiar el sessionStorage y redirigir a la URL original
          sessionStorage.removeItem('returnUrl');
          await this.router.navigateByUrl(returnUrl);
        } else {
          // Si no hay URL guardada, ir a la página principal
          await this.router.navigate(['/']);
        }
      });
    } catch (error: unknown) {
      this.showMessage(
        error instanceof Error ? error.message : 'Unknown error'
      );
    }
  }

  private showMessage(detail: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: detail,
      life: 3000,
    });
  }
}
